import React, {useState, useEffect} from "react";

export default function TextImage(props) {

  const height= window.innerHeight;  
  const width= window.innerWidth;

  //console.log (props.isMobile)

  useEffect(() => {
    const height= window.innerHeight;
    const width= window.innerWidth;
  }, []);

  return (
    props.isMobile ? (
      <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
        height: "100vh"
        }}
        >
        <img
            src={props.src}
            width = {width}
            alt="description of image"
             >
        </img>
      </div>
    ):
  <div
    style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
    }}>
      <img
          src={props.src}
          height= {height}
          alt="description of image"
           >
      </img>
    </div>  
  )
}